import type { UploadFile } from 'antd';

const DEFAULT_PRICING_UPLOAD_ERROR = 'Pricing file failed to upload.';

export function pricingUploadErrorMessage(file: UploadFile | undefined): string {
  const response = file?.response;
  if (typeof response === 'string' && response.trim() !== '') {
    try {
      const parsed = JSON.parse(response);
      if (typeof parsed?.error === 'string' && parsed.error !== '') return parsed.error;
    } catch {
      return response;
    }
  }
  if (typeof response?.error === 'string' && response.error !== '') return response.error;
  return DEFAULT_PRICING_UPLOAD_ERROR;
}
